import * as types from "./actionTypes";

const initialState = {
    fio: '',
    paySum: 0,
    payDate: '',
    refundSum: 0,
    refundDate: '',
    allRefunds: '',
};

export const modal = (state = initialState, action) => {

    switch (action.type) {

        case types.SET_MODAL_INFO:
            return {
                ...state,
                fio: action.fio,
                paySum: action.paySum,
                payDate: action.payDate,
                refundSum: action.refundSum,
                refundDate: action.refundDate,
                allRefunds: action.allRefunds,
            };

        default:
            return state;

    }

};


// WEBPACK FOOTER //
// ./src/js/store/modal/reducers.js